module.exports = __webpack_public_path__ + "img/refused.7665b42c.svg";